import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SubMenu from './SubMenu';

function Layout() {
  const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });
  const headerRef = useRef(null);
  // handle scroll event
  const handleScroll = (elTopOffset, elHeight) => {
    if (window.pageYOffset > (elTopOffset + elHeight)) {
      setSticky({ isSticky: true, offset: elHeight });
    } else {
      setSticky({ isSticky: false, offset: 0 });
    }
  };
  // add/remove scroll event listener
  useEffect(() => {
    var header = headerRef.current.getBoundingClientRect();
    const handleScrollEvent = () => {
      handleScroll(header.top, header.height)
    }
    window.addEventListener('scroll', handleScrollEvent);
    return () => {
      window.removeEventListener('scroll', handleScrollEvent);
    };
  }, []);

  
  return (
    <>
      <div className="header-top d-none d-lg-block">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-3 col-md-9">
              <div className="welcome-text">
                <span>Winter-Season Sale Up To 25% OFF</span>
              </div>
            </div>
            <div className="col-lg-9 col-md-9">
              <div className="top-right text-right">
                <ul>
                  <li>
                    <Link to="/wishlist">
                      <i className="icon-heart"></i>Wishlist
                    </Link>
                  </li>
                  <li className="top_links">
                    <Link to="#">
                      Setting
                      <i className="fa fa-angle-down" aria-hidden="true"></i>
                    </Link>
                    <ul className="drop-links">
                      <li>
                        <Link to="/login">Sign in</Link>
                      </li>
                      <li>
                        <Link to="/checkout">Checkout </Link>
                      </li>
                      <li>
                        <Link to="/account">My Account </Link>
                      </li>
                      <li>
                        <Link to="/cart">Shopping Cart</Link>
                      </li>
                    </ul>
                  </li>
                  <li className="currency switcher-currency-trigger">
                    <Link to="#">
                      <span className="current-currency">USD</span>
                      <i className="fa fa-angle-down" aria-hidden="true"></i>
                    </Link>
                    <ul
                      className="drop-currency switcher-dropdown"
                      id="currencies"
                    >
                      <li data-currency="USD" className="currency-item active">
                        <Link to="#" style={{ cursor: "pointer" }}>
                          USD - US Dollar
                        </Link>
                      </li>
                      <li data-currency="EUR" className="currency-item">
                        <Link to="#" style={{ cursor: "pointer" }}>
                          EUR - Euro
                        </Link>
                      </li>
                      <li data-currency="GBP" className="currency-item">
                        <Link to="#" style={{ cursor: "pointer" }}>
                          GBP - British Pound
                        </Link>
                      </li>
                      <li data-currency="INR" className="currency-item">
                        <Link to="#" style={{ cursor: "pointer" }}>
                          INR - Indian Rupee
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div> 
      <header className="header">
        <div className="topbar">
          <div className="container-fluid">
            <div className="inner">
              <div className="logo">
                <Link to="/"><img src="/tm/react/toolways/assets/images/logo.png" className="image-fit" alt="logo"/></Link>
              </div>
              <div className="search-form">
                <form>
                  <div className="input-group">
                    <input type="text" name="#" className="form-control" placeholder="Search for products..." autoComplete="off" required />
                    <div className="input-group-append input-group-text">
                      <button type="submit"><i className="fal fa-search"></i></button> 
                    </div>
                  </div>
                 
                </form>
              </div>
              <div className="header_action">
                <ul>
                  <li>
                    <Link to="/wishlist">
                      <i className="far fa-heart"></i>
                    </Link>
                  </li>
                  <li className="cart">
                    <Link to="/cart">
                      <span className="cart_value">0</span>
                      <i className="fa fa-shopping-cart"></i>
                    </Link>
                  </li>
                  <li className="user">
                    <Link to="account">
                      <img
                        src="/tm/react/toolways/assets/images/header/user.jpg"
                        className="image-fit"
                        alt="img"
                      />
                    </Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="login">Login</Link>
                      </li>
                      <li>
                        <Link to="register">SignUp</Link>
                      </li>
                      <li>
                        <Link to="account">My Account</Link>
                      </li>
                      <li>
                        <Link to="login">Logout</Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className={`navbara${sticky.isSticky ? ' sticky' : ''}`} ref={headerRef}>
      <div className="logo-responsive">
                <Link to="/"><img src="/tm/react/toolways/assets/images/logo.png" className="image-fit" alt="logo"/></Link>
              </div>
        <div className="main_navigation hide_cat">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-9 col-6">
                <div className="nav_inner">
                  <ul className="main-menu">
                    <li className="menu-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="menu-item menu-item-has-children">
                      <Link to="">Pages</Link>
                      <ul className="sub-menu">
                        <li className="menu-item">
                          <Link to="/privacy">Privacy</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/payment">Payments</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/order">Order</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/order-details">Order Details</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/checkout">Checkout</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/error">Error Page</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/thankyou">Thank You Page</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="menu-item menu-item-has-children">
                      <Link to="#">Shop</Link>
                      <ul className="sub-menu">
                        <li className="menu-item">
                          <Link to="/shop">Shop</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/shop-details">Shop Detail</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="menu-item menu-item-has-children">
                      <Link to="#">Blog</Link>
                      <ul className="sub-menu">
                        <li className="menu-item">
                          <Link to="/blog">Blog</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/blog-details">Blog Details</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/blog-left">Blog Left Sidebar</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/blog-right">Blog Right Sidebar</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="menu-item">
                      <Link to="/about">About Us</Link>
                    </li>
                    <li className="menu-item">
                      <Link to="/faqs">FAQ</Link>
                    </li>
                    <li className="menu-item">
                      <Link to="/terms-conditions">T&C</Link>
                    </li>

                    <li className="menu-item">
                      <Link to="/contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-6">
                <div className="customer_support">
                  <div className="support_img_icon">
                    <img src="/tm/react/toolways/assets/images/customer-service.png" alt="img"/>
                  </div>
                  <div className="customer_support_text">
                    <p>
                      <span>Customer Support</span>
                      <Link to="#">
                        {/* <blink>(08)12345789</blink> */}
                      </Link>
                    </p>
                  </div>
                </div>
                <SubMenu/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Layout